import { useEffect, useState } from "react";
import { CustomButton } from "../../widgets";
import CreateRules from "./CreateRules";
import { getFormVariables, getRules } from "./apiController";
import { useDispatch } from "react-redux";
import { setLoading } from "../../store/slices/auth";

const FormRules = (props) => {
     const { projectData, onClose, selectedFormId } = props;
     const [actions, setaction] = useState("");
     const [rules, setRules] = useState([]);
     const [formvariables, setformVariables] = useState<any>([]);
     const dispatch = useDispatch();

     useEffect(() => {
          console.log("FormRules component mounted", props)
     }, [actions])

     useEffect(() => {
          fetchFormVariables(selectedFormId)
          fetchRules(selectedFormId);
     }, [])

     const handleClose = () => {
          setaction("");
     }

     /**
      * fetch list of rules for the selected form
      */
     const fetchRules = async (id) => {
          try {
               let response = await getRules(id);
               setRules(response && response.data)
               console.log(response);
          } catch (error) {

          }
     }

     /**
     * get variables data
     * @param formData 
     */
     const fetchFormVariables = async (formData) => {
          try {
               dispatch(setLoading(true));
               let response = await getFormVariables(formData);
               setformVariables([]);
               //setformVariablesValue(response.data);
               let tempArray: any = [];
               response.data.map((item, i) => {
                    let Obj = {
                         label: item.field_name.trim(),
                         value: item.field_name.trim(),
                         id: item.id.trim(),
                         field_value: item.field_value,
                         field_type: item.field_type
                    }
                    tempArray.push(Obj)
                    //setformVariables(prevState => [...prevState, Obj]);
               })
               setformVariables(tempArray);
               dispatch(setLoading(false));
               return tempArray;

          } catch (e: any) {
               setformVariables([]);
               dispatch(setLoading(false));
          }
     }

  

     /**
      * This function is used to add a new rule to the form
      */
     return (
          <>
               {
                    actions == "add" &&
                    <CreateRules {...props} onClose={handleClose} fetchRules={fetchRules} variables={formvariables} prevRules={rules && rules.length > 0 ? rules : []} />
               }
               <div className={window.innerWidth < 768 ? "form-rules-container-mobile" : "form-rules-container"}>
                    <div className="form-rules-head">
                         <div className="form-rules-head-text">
                              {projectData && projectData.TopicDesc}
                         </div>
                         <div className="rules-close-btn">
                              <i className="icon icon-close" onClick={() => onClose()}></i>
                         </div>
                    </div>
                    <div className="rules-content">
                         <div className="rule-btn-container">
                              <CustomButton type={"primary"} text={rules && rules.length > 0 ? "Edit Rule" : "Add Rule"} onClick={() => setaction("add")} />
                         </div>
                    </div>
                    <div className="rules-list">
                         <h4>Rules List</h4>
                         {
                              rules && rules.map((item : any , index) => (
                                   <div key={index} className="rule-item">
                                        <div className="rule-item-text">
                                             {item && item.split('endrule')[1]+" endrule"}
                                        </div>
                                   </div>
                              ))
                         }
                    </div>
               </div>
          </>
     )
}

export default FormRules;